// React
import { useContext } from "react"

// Components
import { Loading } from "components"
import { InputSection } from "../components"

// Contexts
import { DisabledContext } from "../../contexts"
import { DataContext, DataBillContext } from "../contexts"

// Form
import { FormProvider, useForm } from "react-hook-form"

// Types
import type { FormType, DetailFormType } from "../utils"

// Utils
import { useBillDetail } from "../utils"

export function DetailBill(params: {
  bill_id: string
  purchase_order_id: string
}): JSX.Element {
  // Hooks
  const { purchase_order_id, bill_id } = params
  const { billData, data, isLoading } = useBillDetail(purchase_order_id!, bill_id!)

  if (isLoading || !data) {
    return (
      <Loading
        errorText="No data available"
        loading={isLoading}
      />
    )
  }

  return (
    <DisabledContext.Provider value={true}>
      <DataBillContext.Provider value={billData!}>
        <DataContext.Provider value={data}>
          <FormSection
            freight={data.freight}
            probildetail={data.probildetail}
            trx_code={data.trx_code}
          />
        </DataContext.Provider>
      </DataBillContext.Provider>
    </DisabledContext.Provider>
  )
}

export function FormSection(params: {
  freight: number
  probildetail: DetailFormType[]
  trx_code: string
}) {
  // Hooks
  const dataBill = useContext(DataContext)

  // Vars
  const datapo = dataBill.datapo

  // Form
  const defaultValues: FormType = {
    delivery_no: datapo.delivered.toString(),
    trx_code: params.trx_code,
    freight: params.freight,
    probildetail: params.probildetail,
    address: datapo.address,
    location_id: datapo.location_id,
    memo: datapo.memo,
    payment_term: datapo.payment_term,
    promise_date: datapo.promize_date,
    purchase_order_id: datapo.purchase_order_id,
    referensi: datapo.referensi,
    reminder: dataBill.reminder,
    tax_inclusive: datapo.tax_inclusive,
    transaction_date: datapo.transaction_date,
    vendor_id: datapo.vendor_id
  }
  const methods = useForm<FormType>({
    defaultValues,
  })

  return (
    <FormProvider {...methods}>
      <InputSection />
    </FormProvider>
  )
}